/* eslint-env es6 */
import uriTemplates from 'uri-templates';
import { capitalize, valuePromise } from './util.es6';

// https://dev.twitch.tv/docs/v5/guides/irc/
// https://github.com/justintv/Twitch-API/blob/master/IRC.md

const API_BASE = 'https://api.twitch.tv/kraken';
const CLIENT_ID = '2ukwwky442jlp85of7gtonyht8r8awc';
const API_VERSION_TYPE = 'application/vnd.twitchtv.v5+json';

const USERID_URL = API_BASE + '/users?login={user}';
const CHANNEL_BADGE_URL = API_BASE + '/chat/{channel}/badges';
const CHANNEL_ROOMS_URL = API_BASE + '/chat/{channel}/rooms';
const CHANNEL_STREAM_INFO_URL = API_BASE + '/streams?channel={channels}';
const CHANNEL_INFO_URL = API_BASE + '/channels/{channel}';
const BITS_ACTION_URL = API_BASE + '/bits/actions?channel_id={channel}';
const CHANNEL_STREAM_POPUP_URL = 'https://player.twitch.tv/?channel={channel}&volume=1&parent={parent}';
const GLOBAL_BADGE_URL = 'https://badges.twitch.tv/v1/badges/global/display';
const ROOMID_BADGE_URL = 'https://badges.twitch.tv/v1/badges/channels/{room_id}/display';

let CHANNEL_INFO_PROMISES = {};
let CHANNEL_BADGE_PROMISES = {};
let ROOMID_BADGE_PROMISES = {};

let GLOBAL_BADGE_PROMISE;
let BITS_ACTION_PROMISE = {};
let BITS_ACTIONS = {};
let BITS_REGEX = {};
let BITS_REGEX_G = {};
const COLOR_RE = /^#[a-f0-9]{6,6}$/i;
const AL_RE = /^[a-z]{1,100}$/i;

const STATIC_CDN_BASE_URL = 'https://static-cdn.jtvnw.net';
const DEFAULT_PROFILE_PICS_BASE = STATIC_CDN_BASE_URL + '/user-default-pictures/';
const DEFAULT_PROFILE_PIC_SUFFIX = '-profile_image-{size}x{size}.jpg';
const DEFAULT_PROFILE_PICS = [
    'bb97f7e6-f11a-4194-9708-52bf5a5125e8',
    '27103734-3cda-44d6-a384-f2ab71e4bb85',
    '49988c7b-57bc-4dee-bd4f-6df4ad215d3a',
    '0ecbb6c3-fecb-4016-8115-aa467b7c36ed',
    'cd618d3e-f14d-4960-b7cf-094231b04735',
    '4cbf10f1-bb9f-4f57-90e1-15bf06cfe6f5',
    'b83b1794-7df9-4878-916c-88c2ad2e4f9f'
];

export function numDefaultAvatars () {
    return DEFAULT_PROFILE_PICS.length;
}
export function defaultAvatar (options = {}) {
    var idx = options.idx;
    if (idx === undefined) {
        idx = _.random(0, numDefaultAvatars() - 1);
    }
    return DEFAULT_PROFILE_PICS_BASE + DEFAULT_PROFILE_PICS[idx] + DEFAULT_PROFILE_PIC_SUFFIX;
}

export function usernamesToIds (session, usernames) {
    return ajax(session, {
        url: uriTemplates(USERID_URL).fill({
            user: usernames
        }),
        dataType: 'json'
    });
}

export function bitsAction (session, channel) {
    if (!BITS_ACTION_PROMISE[channel]) {
        BITS_ACTION_PROMISE[channel] = new Promise(function bitsActionProcess (resolve, reject) {
            channelsToInfo(session, [channel]).then(function (channelInfo) {
                if (channelInfo && channelInfo[channel]) {
                    ajax(session, {
                        url: uriTemplates(BITS_ACTION_URL).fill({
                            channel: channelInfo[channel]._id
                        }),
                        dataType: 'json'
                    }).done(function bitsActionProcessDone (response, status, jqXHR) {
                        if (response && response.actions && response.actions.length) {
                            let actions = response.actions.forEach(function bitsActionMap (action) {
                                if (_.isString(action.prefix) && AL_RE.test(action.prefix) && action.tiers) {
                                    BITS_ACTIONS[action.prefix.toLowerCase()] = action.tiers;
                                }
                            });
                            let re = '\\b(' + Object.keys(BITS_ACTIONS).join('|') + ')(\\d+)\\b';
                            BITS_REGEX[channel] = new RegExp(re, 'i');
                            BITS_REGEX_G[channel] = new RegExp(re, 'gi');
                        }
                        resolve(response);
                    });
                } else {
                    resolve();
                }
            });
        });
    }
    return BITS_ACTION_PROMISE[channel];
}

export function channelsToInfo (session, channels) {
    var chanString = channels.join(',');
    if (!CHANNEL_INFO_PROMISES[chanString]) {
        let promise = new Promise(function fetchChannelIdProcess (resolve, reject) {
            usernamesToIds(session, channels).done(function fetchUserIdDone (response, status, jqXHR) {
                if (response && response.users && response.users.length) {
                    let channelIds = {};
                    response.users.forEach(u => channelIds[u.name] = u);
                    resolve(channelIds);
                } else {
                    delete CHANNEL_INFO_PROMISES[chanString];
                    channels.forEach(chan => {
                        delete CHANNEL_INFO_PROMISES[chan];
                    });
                    resolve();
                }
            });
        });
        CHANNEL_INFO_PROMISES[chanString] = promise;
        channels.forEach(chan => {
            CHANNEL_INFO_PROMISES[chan] = promise;
        });
    }
    return CHANNEL_INFO_PROMISES[chanString];
}

export function popupStream (session, channel) {
    let url = uriTemplates(CHANNEL_STREAM_POPUP_URL).fill({
        channel: channel,
        parent: session.getHost()
    });
    let title = 'twitchStreamPopup';
    let w = 960;
    let h = 540;

    // Fixes dual-screen position                         Most browsers      Firefox
    let dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    let dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    let left = ((width / 2) - (w / 2)) + dualScreenLeft;
    let top = ((height / 2) - (h / 2)) + dualScreenTop;

    let specs = 'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left + ',menubar=0,status=1';
    let newWindow = window.open('', title, specs);
    newWindow.opener = null;
    newWindow.location.href = url;
}

export function parseBadgeTag (tag, asObject) {
    let badges = [];
    if (asObject) {
        badges = {};
    }
    if (tag) {
        tag.split(',').forEach(function parseBadgeTagEach (part) {
            let match = part.match(/([a-z\d_-]+)\/(\d+)/);
            if (match) {
                if (asObject) {
                    badges[match[1]] = match[2];
                } else {
                    badges.push({
                        type: match[1],
                        value: match[2]
                    });
                }
            }
        });
    }
    return badges;
}

export function channelBadgeUrl (session, channel, roomId, badge) {
    return new Promise(function channelBadgeUrlProcess (resolve, reject) {
        if (badge.type === 'subscriber') {
            if (roomId) {
                resolve(fetchRoomIdSubBadge(session, roomId, badge.value));
            } else {
                resolve(fetchChannelSubBadge(session, channel));
            }
        } else {
            resolve(globalBadgeUrl(session, badge.type, badge.value));
        }
    });
}

function globalBadgeUrl (session, type, value) {
    return new Promise(function globalBadgeUrlProcess (resolve, reject) {
        fetchGlobalBadge(session).then(function globalBadgeUrlFetchDone (response) {
            resolve(lookupGlobalBadgeData(response, type, value));
        });
    });
}

function matchCheers (channel, input) {
    if (BITS_REGEX[channel]) {
        let cheers = input.match(BITS_REGEX_G[channel]);
        if (cheers) {
            return cheers.map(function (cheer) {
                let cheerParts = cheer.match(BITS_REGEX[channel]);
                return {
                    text: cheerParts[0],
                    value: cheerParts[2],
                    type: cheerParts[1].toLowerCase()
                };
            });
        }
    }
}

export function splitCheerParts (channel, input) {
    let cheers = matchCheers(channel, input);
    if (cheers) {
        let parts = [];
        let parsedIndex = 0;
        cheers.forEach(function splitCheerPartsEach (cheer) {
            let textValue = input.slice(parsedIndex, input.indexOf(cheer.text, parsedIndex));
            if (textValue !== '') {
                parts.push({
                    text: textValue
                });
            }
            let part = {
                cheer: true,
                text: cheer.text,
                value: cheer.value,
                tier: bitsTier(cheer.value),
                type: cheer.type
            };
            if (
                BITS_ACTIONS[part.type][part.tier] &&
                BITS_ACTIONS[part.type][part.tier].images &&
                BITS_ACTIONS[part.type][part.tier].images.light &&
                BITS_ACTIONS[part.type][part.tier].images.dark &&
                BITS_ACTIONS[part.type][part.tier].images.light.animated &&
                BITS_ACTIONS[part.type][part.tier].images.dark.animated &&
                BITS_ACTIONS[part.type][part.tier].images.light.animated[1] &&
                BITS_ACTIONS[part.type][part.tier].images.dark.animated[1]
            ) {
                parts.push(part);
            } else {
                parts.push({
                    text: cheer.text
                });
            }
            parsedIndex += textValue.length + cheer.text.length;
        });
        let textValue = input.slice(parsedIndex);
        if (textValue !== '') {
            parts.push({
                text: textValue
            });
        }
        return parts;
    } else {
        return [{
            text: input
        }];
    }
}

export function cheerUrl (type, tier, theme = 'light', size = 1, animated = true) {
    let state = animated ? 'animated' : 'static';
    return BITS_ACTIONS[type][tier].images[theme][state][size];
}

export function cheerValue (type, tier, value) {
    let valueInt = value - 0;
    if (valueInt >= 10000) {
        valueInt = Number(valueInt).toLocaleString();
    }
    let color = BITS_ACTIONS[type][tier].color;
    let colorStyle = '';
    if (COLOR_RE.test(color)) {
        colorStyle = ' style="color: ' + color + ';"';
    }
    let span = '<span class="twitchCheer__value"' + colorStyle + '>';
    span += valueInt;
    span += '</span>';
    return span;
}

export function fetchChannelInfo (session, channel) {
    // https://dev.twitch.tv/docs/v5/reference/channels/#get-channel-by-id
    return new Promise(function fetchChannelInfoProcess (resolve, reject) {
        channelsToInfo(session, [channel]).then(function (channelInfo) {
            if (channelInfo && channelInfo[channel]) {
                ajax(session, {
                    url: uriTemplates(CHANNEL_INFO_URL).fill({
                        channel: channelInfo[channel]._id
                    }),
                    dataType: 'json'
                }).done(function fetchChannelInfoDone (response, status, jqXHR) {
                    resolve(response);
                });
            } else {
                resolve();
            }
        });
    });
}

export function fetchStreamInfo (session, channels, auth) {
    // Streams support multi-get, channels don't
    // https://dev.twitch.tv/docs/v5/reference/streams/#get-stream-by-channel
    return new Promise(function fetchStreamInfoProcess (resolve, reject) {
        channelsToInfo(session, channels).then(function fetchStreamInfoIdAll (channelInfo) {
            if (!channelInfo) {
                resolve();
                return;
            }
            let channelStreamInfo = {};
            let filteredChannelIds = _.filter(_.pluck(channelInfo, '_id'), _.identity);
            if (!filteredChannelIds.length) {
                resolve(channelStreamInfo);
                return;
            }
            ajax(session, {
                url: uriTemplates(CHANNEL_STREAM_INFO_URL).fill({
                    channels: filteredChannelIds
                }),
                dataType: 'json'
            }).done(function fetchStreamInfoDone (response, status, jqXHR) {
                if (response && _.isArray(response.streams)) {
                    response.streams.forEach(function fetchStreamInfoEach (stream) {
                        if (stream.channel && _.isString(stream.channel.name)) {
                            channelStreamInfo[stream.channel.name.toLowerCase()] = stream;
                        }
                    });
                }
                let promises = _.map(channels, function fetchStreamInfoCheckEach (channel) {
                    if (channelStreamInfo[channel]) {
                        return fetchChannelRooms(session, channel, auth).then(
                            function fetchChannelRoomsThen(rooms) {
                                channelStreamInfo[channel].rooms = rooms;
                                return [channel, channelStreamInfo[channel]];
                            }
                        );
                    } else {
                        return fetchChannelInfo(session, channel).then(function fetchChannelInfoThen (response) {
                            if (response && response.name) {
                                channelStreamInfo[channel] = {
                                    channel: response
                                };
                                return fetchChannelRooms(session, channel, auth).then(
                                    function fetchChannelRoomsThen(rooms) {
                                        channelStreamInfo[channel].rooms = rooms;
                                        return [channel, channelStreamInfo[channel]];
                                    }
                                );
                            } else {
                                return [channel, {error: response}];
                            }
                        });
                    }
                });
                Promise.all(promises).then(function fetchStreamInfoAll (values) {
                    resolve(channelStreamInfo);
                });
            });
        });
    });
}

function ajax (session, options = {}) {
    options.headers = options.headers || {};
    options.headers['Client-ID'] = CLIENT_ID;
    options.headers['Accept'] = API_VERSION_TYPE;
    if (options.auth) {
        options.headers['Authorization'] = 'OAuth ' + options.auth;
    }
    options.silent = true;
    return session.ajax(options, null, function ajaxErrortest (jqXHR, errorString, errorThrown) {
        // Suppress ajax errors
        return false;
    });
}

// Private

function bitsTier (value) {
    if (value >= 10000) {
        return 4;
    } else if (value >= 5000) {
        return 3;
    } else if (value >= 1000) {
        return 2;
    } else if (value >= 100) {
        return 1;
    } else {
        return 0;
    }
}

function lookupGlobalBadgeData (json, type, value) {
    if (value === undefined) {
        value = 1;
    }
    if (json && json.badge_sets && json.badge_sets[type] && json.badge_sets[type].versions && json.badge_sets[type].versions[value]) {
        return {
            url: json.badge_sets[type].versions[value].image_url_1x,
            url2x: json.badge_sets[type].versions[value].image_url_2x,
            url4x: json.badge_sets[type].versions[value].image_url_4x,
            title: json.badge_sets[type].versions[value].title
        };
    }
}

function lookupChannelSubBadge (json) {
    if (json && json.subscriber) {
        let url = json.subscriber.image;
        let data = {
            url: url,
            title: 'Subscriber'
        };
        return data;
    }
}

function fetchGlobalBadge (session) {
    if (!GLOBAL_BADGE_PROMISE) {
        GLOBAL_BADGE_PROMISE = new Promise(function fetchGlobalBadgeProcess(resolve, reject) {
            ajax(session, {
                url: GLOBAL_BADGE_URL,
                dataType: 'jsonp'
            }).done(function fetchGlobalBadgeDone (response, status, jqXHR) {
                resolve(response);
            });
        });
    }

    return GLOBAL_BADGE_PROMISE;
}

function fetchChannelSubBadge (session, channel) {
    if (!CHANNEL_BADGE_PROMISES[channel]) {
        CHANNEL_BADGE_PROMISES[channel] = new Promise(function fetchChannelSubBadgeProcess (resolve, reject) {
            channelsToInfo(session, [channel]).then(function (channelInfo) {
                if (channelInfo && channelInfo[channel]) {
                    ajax(session, {
                        url: uriTemplates(CHANNEL_BADGE_URL).fill({
                            channel: channelInfo[channel]._id
                        }),
                        dataType: 'json'
                    }).done(function fetchChannelSubBadgeDone (response, status, jqXHR) {
                        resolve(lookupChannelSubBadge(response));
                    });
                } else {
                    resolve();
                }
            });
        });
    }
    return CHANNEL_BADGE_PROMISES[channel];
}

export function fetchChannelRooms (session, channel, auth) {
    return new Promise(function fetchChannelRoomsProcess (resolve, reject) {
        channelsToInfo(session, [channel]).then(function (channelInfo) {
            if (channelInfo && channelInfo[channel]) {
                ajax(session, {
                    url: uriTemplates(CHANNEL_ROOMS_URL).fill({
                        channel: channelInfo[channel]._id
                    }),
                    auth: auth,
                    dataType: 'json'
                }).done(function fetchChannelRoomsDone (response, status, jqXHR) {
                    if (response && _.isArray(response.rooms)) {
                        resolve(response.rooms);
                    } else {
                        resolve();
                    }
                });
            } else {
                resolve();
            }
        });
    });
}

export function roomChannel (channelId, room) {
    return '#chatrooms:' + channelId + ':' + room;
}

export function roomType (roomInfo) {
    switch (roomInfo.minimum_allowed_role) {
    case 'MODERATOR':
        return 'Mods-only';
    case 'EVERYONE':
        return 'Public';
    case 'SUBSCRIBER':
        var type = 'Subs-only';
        if (roomInfo.is_previewable) {
            type += ' (previewable)';
        }
        return type;
    }
}

function fetchRoomIdSubBadge (session, roomId, value) {
    if (!ROOMID_BADGE_PROMISES[roomId]) {
        ROOMID_BADGE_PROMISES[roomId] = {};
    }
    if (!ROOMID_BADGE_PROMISES[roomId][value]) {
        ROOMID_BADGE_PROMISES[roomId][value] = new Promise(function fetchRoomIdSubBadgeProcess (resolve, reject) {
            ajax(session, {
                url: uriTemplates(ROOMID_BADGE_URL).fill({
                    room_id: roomId
                }),
                dataType: 'jsonp'
            }).done(function fetchRoomIdSubBadgeDone (response, status, jqXHR) {
                resolve(lookupGlobalBadgeData(response, 'subscriber', value));
            });
        });
    }
    return ROOMID_BADGE_PROMISES[roomId][value];
}

export function loadBadges (session, channel, els) {
    var selector = '.twitch_badges';
    var items = els.find(selector);
    items.each(function loadTwitchBadgesEach (i, badge) {
        var $badge = $(badge);
        var roomId = $badge.data('twitch_room_id');
        var types = parseBadgeTag($badge.data('twitch_badges'));
        var typeInfo = parseBadgeTag($badge.data('twitch_badge_info'), true);
        _.each(types, function loadTwitchBadgesTypesEach (type) {
            var className = 'twitch_badge twitch_badge__' + type.type;
            var badgeContainer = $('<span>').addClass(className);
            $badge.append(badgeContainer);
            channelBadgeUrl(
                session,
                channel,
                roomId,
                type
            ).then(function onTwitchbadgeUrl (data) {
                if (data) {
                    var title = data.title;
                    if (typeInfo[type.type]) {
                        title += ', ' + typeInfo[type.type] + '-Month Subscriber';
                    }
                    var img = $('<img>').attr({
                        title: title,
                        alt: title,
                        src: data.url,
                        width: 18,
                        height: 18
                    });
                    var srcset = [];
                    if (data.url2x) {
                        srcset.push(data.url2x + ' 2x');
                    }
                    if (data.url4x) {
                        srcset.push(data.url4x + ' 4x');
                    }
                    if (srcset.length) {
                        img.attr('srcset', srcset.join(', '));
                    }
                    badgeContainer.append(img);
                }
            });
        });
    });
}


// WEBPACK FOOTER //
// ./app/src/lib/twitch.es6